import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-end m-9 mr-0 ml-0" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Dodaj dokument ")

import { computed } from 'vue'
import {
    UiHeading,
    UiContainer,
    UiPagination,
    UiButton,
    UiPopover,
    UiTooltip,
    UiFiltersTrigger,
} from '@/components/common/ui'
import { AppLoadingContent, TheFallback } from '@/components/common'
import { usePaginationUrlQuery } from '@/composables/usePaginationUrlQuery'
import { useFiltersStorage } from '@/composables/useFiltersStorage'
import { useAdviceStatuses } from '@/composables/useAdvicesStatuses'
import { useAdvices, AdviceListFilters } from '@/composables/useAdvices'
import { useInvoiceStatuses } from '@/composables/useInvoiceStatuses'
import { useAdviceDocuments } from '@/composables/useAdviceDocuments'
import AdvicesList from '@/components/advices/AdvicesList.vue'
import AppFilteringForm from '@/components/common/AppFilteringForm.vue'
import AppActiveFiltersList from '@/components/common/AppActiveFiltersList.vue'
import router from '@/router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { selectedAdvices, fetchInvoiceData } = useAdviceDocuments()
fetchInvoiceData()

const { fetchAdviceStatuses, adviceStatuses } = useAdviceStatuses()
fetchAdviceStatuses()

const { fetchInvoiceStatuses, invoiceStatuses } = useInvoiceStatuses()
fetchInvoiceStatuses()

const { fetchAdvices, advices, loading, isEmpty } = useAdvices()
const { currentPage, updateUrlQuery } = usePaginationUrlQuery()
const { currentFilters } = useFiltersStorage<AdviceListFilters>('advices')

const downloadAdvices = () => {
    fetchAdvices({ page: currentPage.value, filters: currentFilters.value })
}
downloadAdvices()

const handleChangePage = (newPage: number) => {
    fetchAdvices({ page: newPage, filters: currentFilters.value })
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const handleFilter = (filters: AdviceListFilters, close?: () => void) => {
    if (close) close()
    updateUrlQuery('1')
    fetchAdvices({ page: 1, filters })
}
const ableToAddInvoice = computed(() => {
    return selectedAdvices.value.length > 0
})
const onAddInvoiceClick = () => {
    router.push({ name: 'add-invoice' })
}

return (_ctx: any,_cache: any) => {
  const _component_IconCross = _resolveComponent("IconCross")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(UiHeading), { title: "Zlecenia" }, {
      default: _withCtx(() => [
        _createVNode(_unref(UiPopover), {
          position: "stick-to-right",
          width: 700
        }, {
          refferer: _withCtx(() => [
            _createVNode(_unref(UiFiltersTrigger), {
              "filters-length": _unref(currentFilters) && Object.keys(_unref(currentFilters)).length
            }, null, 8, ["filters-length"])
          ]),
          content: _withCtx(({ close }) => [
            _createVNode(AppFilteringForm, {
              columns: "",
              "use-filter-storage": "advices",
              "filters-schema": [
                        {
                            type: 'select',
                            key: 'adviceStatusId',
                            label: 'Status zlecenia',
                            options: _unref(adviceStatuses),
                        },
                        {
                            type: 'select',
                            key: 'invoiceStatusId',
                            label: 'Status załączonej faktury',
                            options: _unref(invoiceStatuses),
                        },
                        {
                            type: 'input',
                            key: 'vehicleIdentificationNumber',
                            label: 'Numer rejestracyjny',
                        },
                        { type: 'input', key: 'driverFirstName', label: 'Imię kierowcy' },
                        { type: 'input', key: 'driverLastName', label: 'Nazwisko kierowcy' },
                        { type: 'date-range', key: 'loadingDate', label: 'Data załadunku' },
                        { type: 'date-range', key: 'deliveryDate', label: 'Data dostawy' },
                    ],
              "cancel-button-text": "Usuń filtry",
              onSubmit: filters => handleFilter(filters as AdviceListFilters, close)
            }, null, 8, ["filters-schema", "onSubmit"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(UiContainer), null, {
      default: _withCtx(() => [
        _createVNode(AppActiveFiltersList, {
          clerable: "",
          "use-filter-storage": "advices",
          class: "hidden md:flex",
          "filters-schema": [
                {
                    type: 'select',
                    key: 'adviceStatusId',
                    label: 'Status zlecenia',
                    options: _unref(adviceStatuses),
                },
                {
                    type: 'select',
                    key: 'invoiceStatusId',
                    label: 'Status załączonej faktury',
                    options: _unref(invoiceStatuses),
                },
                {
                    type: 'input',
                    key: 'vehicleIdentificationNumber',
                    label: 'Numer rejestracyjny',
                },
                { type: 'input', key: 'driverFirstName', label: 'Imię kierowcy' },
                { type: 'input', key: 'driverLastName', label: 'Nazwisko kierowcy' },
                { type: 'date-range', key: 'loadingDate', label: 'Data załadunku' },
                { type: 'date-range', key: 'deliveryDate', label: 'Data dostawy' },
            ],
          onRemoveFilter: _cache[0] || (_cache[0] = filters => handleFilter(filters as AdviceListFilters))
        }, null, 8, ["filters-schema"]),
        _createVNode(_unref(AppLoadingContent), { "is-loading": _unref(loading) }, {
          default: _withCtx(() => [
            (_unref(isEmpty))
              ? (_openBlock(), _createBlock(_unref(TheFallback), { key: 0 }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_unref(UiTooltip), {
                      class: "order-3 md:order-2",
                      position: "top",
                      message: "Zaznacz co najmniej jedno zlecenie",
                      disabled: _unref(ableToAddInvoice)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(UiButton), {
                          disabled: !_unref(ableToAddInvoice),
                          primary: "",
                          onClick: onAddInvoiceClick
                        }, {
                          default: _withCtx(() => [
                            _hoisted_2,
                            _createVNode(_component_IconCross, { class: "ml-2" })
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ]),
                  _createVNode(AdvicesList, {
                    advices: _unref(advices).items,
                    onFetchAdvices: downloadAdvices
                  }, null, 8, ["advices"]),
                  _createVNode(_unref(UiPagination), {
                    class: "mt-12",
                    metadata: _unref(advices).metadata,
                    "with-url-query": "",
                    onChangePage: handleChangePage
                  }, null, 8, ["metadata"])
                ], 64))
          ]),
          _: 1
        }, 8, ["is-loading"])
      ]),
      _: 1
    })
  ], 64))
}
}

})